var map = {
	"./AppointmentListView.png": 8684,
	"./ContactView.png": 8907,
	"./ContactsView.png": 6421,
	"./CustomerDetailView.png": 1666,
	"./CustomerView.png": 8749,
	"./CustomerVisitView.png": 5075,
	"./CustomerVisitsView.png": 8334,
	"./DashboardView.png": 3089,
	"./LeadsView.png": 5137,
	"./NotesView.png": 4319,
	"./OffersView.png": 6649,
	"./QuicklinksView.png": 1683,
	"./TasksListView.png": 5020,
	"./TasksView.png": 8140,
	"./UserView.png": 7384,
	"./logo copy.png": 2301,
	"./logo.png": 1511,
	"./pollex_lc_logo copy.jpg": 3257,
	"./pollex_lc_logo copy.png": 2323,
	"./pollex_lc_logo.jpg": 6891,
	"./pollex_lc_logo.png": 6839,
	"./pollex_logo copy.png": 2545,
	"./pollex_logo.png": 7890,
	"Styles/images/AppointmentListView.png": 8684,
	"Styles/images/ContactView.png": 8907,
	"Styles/images/ContactsView.png": 6421,
	"Styles/images/CustomerDetailView.png": 1666,
	"Styles/images/CustomerView.png": 8749,
	"Styles/images/CustomerVisitView.png": 5075,
	"Styles/images/CustomerVisitsView.png": 8334,
	"Styles/images/DashboardView.png": 3089,
	"Styles/images/LeadsView.png": 5137,
	"Styles/images/NotesView.png": 4319,
	"Styles/images/OffersView.png": 6649,
	"Styles/images/QuicklinksView.png": 1683,
	"Styles/images/TasksListView.png": 5020,
	"Styles/images/TasksView.png": 8140,
	"Styles/images/UserView.png": 7384,
	"Styles/images/logo copy.png": 2301,
	"Styles/images/logo.png": 1511,
	"Styles/images/pollex_lc_logo copy.jpg": 3257,
	"Styles/images/pollex_lc_logo copy.png": 2323,
	"Styles/images/pollex_lc_logo.jpg": 6891,
	"Styles/images/pollex_lc_logo.png": 6839,
	"Styles/images/pollex_logo copy.png": 2545,
	"Styles/images/pollex_logo.png": 7890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8114;